import { NotAffectingLineHeightObject } from '@upright/ui/common/generic/components/not-affecting-line-height-object';
import { FocusRing } from '@upright/ui/common/generic/components/focus-ring';
import { RadioRenderProps } from 'react-aria-components';
import styles from './Radio.module.css';

export function RadioCheckmark({ isFocusVisible, isDisabled, isSelected, isInvalid }: RadioRenderProps) {
  return (
    <NotAffectingLineHeightObject>
      <FocusRing isFocusVisible={isFocusVisible}>
        <div
          data-disabled={isDisabled ? 'true' : undefined}
          data-selected={isSelected ? 'true' : undefined}
          data-invalid={isInvalid ? 'true' : undefined}
          className={styles.radio}
        >
          <div className={styles.checkmark} />
        </div>
      </FocusRing>
    </NotAffectingLineHeightObject>
  );
}
